import { SET_RESTRICTIONS, SET_RESTRICTIONS_LOADING, SET_RESTRICTIONS_ACCEPTED } from './actions';
const initialState = {
    restrictions: [],
    loading: false,
    accepted: false
};
function restrictionsReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_RESTRICTIONS:
            return Object.assign(Object.assign({}, state), { restrictions: payload });
        case SET_RESTRICTIONS_LOADING:
            return Object.assign(Object.assign({}, state), { loading: payload });
        case SET_RESTRICTIONS_ACCEPTED:
            return Object.assign(Object.assign({}, state), { accepted: payload });
        default:
            return state;
    }
}
export default restrictionsReducer;
